import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';
import { CartResponse, } from 'common/types';

class CartsRepository extends BaseRepositoryClass implements RepositoryType {
    save() {
        return this
            .requester
            .post<CartResponse>('grant/carts');
    }
}

export default CartsRepository;
